<template>
  <div class="mx-n3 my-3">
    <v-row
      v-for="(row, ri) in layout.rows"
      class="mb-10"
      data-testid="layout-row"
      :key="'row-' + ri"
    >
      <v-col
        sm="12"
        :md="getCols(row.columns.length)"
        v-for="(column, ci) in row.columns"
        :key="'column-' + ci"
        data-testid="layout-col"
      >
        <div
          class="widgets"
          v-for="widgetId in column.widgets"
          :key="widgetId"
          data-testid="layout-widget-wrapper"
        >
          <WidgetsDispatcher :widget="getWidgetById(widgetId)" />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import WidgetsDispatcher from '@/containers/ReportsView/Widgets/WidgetsDispatcher.vue'

const POINT_GRID_LIMIT = 12

export default {
  name: 'FlexColumns',

  components: {
    WidgetsDispatcher,
  },

  props: {
    layout: {
      type: Object,
      required: true,
    },
    widgets: {
      type: Array,
      required: true,
    },
  },

  methods: {
    getWidgetById(widgetId) {
      return this.widgets.find(widget => widget.id === widgetId) || {}
    },

    getCols(length) {
      return Math.ceil(POINT_GRID_LIMIT / length)
    },
  },
}
</script>
